<div class="ot-dropdown" [ngClass]="{'ot-dropdown--is-active': showList}">
  <div class="ot-form-control" style="flex: 1;padding-right: 16px;margin-bottom:8px">
    <input [id]="identifier" #prodFileInputText maxLength="25" i18n-placeholder placeholder="Enter a file name" type="text" class="ot-input" [(ngModel)]="queryText" (focus)="onFocus()" (ngModelChange)="onQueryTextChanged($event)" autocomplete="off">
  </div>
</div>
<ng-template #dropdownMenu>
  <ul class="ot-dropdown__menu" [ngStyle]="{'height': scrollHeight, 'width': '100%'}">
    @if(prodFiles.length > 0){
      <ng-scrollbar [visibility]="'always'">
        @for (file of prodFiles; track file) {
          <li class="ot-dropdown__item" (click)="onSelect(file)" [title]="file.displayName">
            <div [innerHtml]="file.displayName | highlightText : queryText"></div>
          </li>
        }
      </ng-scrollbar>
    }
    @else {
    <li class="ot-dropdown__item" id="ot-header__item__notification_no_items_msg">
      There are no product files to display.
    </li>
  }
</ul>
</ng-template>
<div class="ot-chips ot-pl-0 ot-pt-0">
  @if (selectedProdFileName && selectedProdFileName != '') {
    <div class="ot-chip" style="margin-left:0px">
      {{selectedProdFileName}}
      <button class="ot-chip__close" (click)="removeSelectedFile()" title="Remove" i18n-title>
      </button>
    </div>
  }
</div>